(function (app) {
    app.directive("onClickAutofocus", [function () {
        return {
            link: function (scope, element, attrs) {
                scope.$watch(attrs.onClickAutofocus, function (value) {
                    if (value === true) {
                        element[0].focus();
                        scope[attrs.onClickAutofocus] = false;
                    }
                });
            }
        };
    }]);
})(window.app); // jshint ignore:line